export default __webpack_public_path__ + "static/media/paygwaapp-new.ba874d57.png";